(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-timeline-menlab"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('menlab-scroll-timeline')) {
    class MenlabScrollTimeline extends HTMLElement {
      connectedCallback() {
        if (this.isInitialized) return;

        this.content = this.querySelector('[data-timeline-content]');
        this.axis = this.querySelector('[data-timeline-axis]');
        this.items = Array.from(this.querySelectorAll('[data-timeline-item]'));
        this.nodes = Array.from(this.querySelectorAll('[data-timeline-node]'));

        if (!this.content || !this.axis || this.items.length === 0 || this.nodes.length === 0) return;

        this.isInitialized = true;
        this.needsMeasure = true;
        this.rafId = 0;
        this.nodeOffsets = [];
        this.firstOffset = 0;
        this.axisLength = 0;
        this.triggerPercent = Number.parseFloat(this.dataset.triggerPosition) || 50;

        this.handleScroll = () => this.scheduleUpdate();
        this.handleResize = () => this.requestMeasure();
        this.handleImageLoad = () => this.requestMeasure();
        this.handleBlockSelect = (event) => this.onBlockSelect(event);
        this.handleBlockDeselect = (event) => this.onBlockDeselect(event);

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        window.addEventListener('resize', this.handleResize, { passive: true });
        document.addEventListener('shopify:block:select', this.handleBlockSelect);
        document.addEventListener('shopify:block:deselect', this.handleBlockDeselect);

        this.images = Array.from(this.querySelectorAll('img'));
        this.images.forEach((image) => {
          if (!image.complete) image.addEventListener('load', this.handleImageLoad, { once: true });
        });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.requestMeasure());
          this.resizeObserver.observe(this.content);
        }

        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(() => {
            if (this.isConnected) this.requestMeasure();
          });
        }

        this.setAttribute('data-enhanced', '');
        this.update();
      }

      disconnectedCallback() {
        if (!this.isInitialized) return;

        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);

        this.images.forEach((image) => image.removeEventListener('load', this.handleImageLoad));
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.rafId) cancelAnimationFrame(this.rafId);

        this.isInitialized = false;
      }

      requestMeasure() {
        this.needsMeasure = true;
        this.scheduleUpdate();
      }

      scheduleUpdate() {
        if (this.rafId) return;

        this.rafId = requestAnimationFrame(() => {
          this.rafId = 0;
          this.update();
        });
      }

      measure() {
        const contentRect = this.content.getBoundingClientRect();

        this.nodeOffsets = this.nodes.map((node) => {
          const nodeRect = node.getBoundingClientRect();
          return nodeRect.top + nodeRect.height / 2 - contentRect.top;
        });

        this.firstOffset = this.nodeOffsets[0] || 0;
        const lastOffset = this.nodeOffsets[this.nodeOffsets.length - 1] || this.firstOffset;
        this.axisLength = Math.max(0, lastOffset - this.firstOffset);

        this.axis.style.top = `${this.firstOffset}px`;
        this.axis.style.height = `${this.axisLength}px`;
        this.needsMeasure = false;
      }

      update() {
        if (!this.isConnected || !this.content) return;
        if (this.needsMeasure) this.measure();

        const contentRect = this.content.getBoundingClientRect();
        const triggerY = window.innerHeight * (this.triggerPercent / 100);
        const traveled = triggerY - (contentRect.top + this.firstOffset);
        const progress = this.axisLength > 0
          ? Math.max(0, Math.min(1, traveled / this.axisLength))
          : traveled >= 0 ? 1 : 0;

        this.style.setProperty('--st-progress', progress.toFixed(4));

        this.items.forEach((item, index) => {
          const nodeCenter = contentRect.top + (this.nodeOffsets[index] || 0);
          item.classList.toggle('is-active', nodeCenter <= triggerY + 0.5);
        });
      }

      onBlockSelect(event) {
        const item = event.target.closest('[data-timeline-item]');
        if (!item || !this.contains(item)) return;

        this.querySelectorAll('.is-editor-selected').forEach((selected) => {
          selected.classList.remove('is-editor-selected');
        });
        item.classList.add('is-editor-selected');
        item.scrollIntoView({ block: 'center', behavior: 'auto' });
        this.requestMeasure();
      }

      onBlockDeselect(event) {
        const item = event.target.closest('[data-timeline-item]');
        if (!item || !this.contains(item)) return;

        item.classList.remove('is-editor-selected');
        this.scheduleUpdate();
      }
    }

    customElements.define('menlab-scroll-timeline', MenlabScrollTimeline);
  }

  } catch(e) { console.error(e); }
})();
})();
